import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MasterComponent, MasterDetailComponent, PanelComponent } from '@rocksoft/cdk';
import { DevicesStateListContainerComponent, DevicesStateListState } from './devices-state-list.container';

@Component({
  selector: 'era-devices-state-list-view',
  templateUrl: './devices-state-list-view.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MasterDetailComponent, MasterComponent, PanelComponent, DevicesStateListContainerComponent],
})
export class DevicesStateListViewComponent {
  readonly state = input<DevicesStateListState>('unassigned');
}
